import { useState, HTMLInputTypeAttribute } from 'react'
import { FieldError, FieldErrorsImpl, Merge } from 'react-hook-form'
import viewPassTextIcon from '../../assets/images/view-pass-text.svg'
import hidePassTextIcon from '../../assets/images/hide-pass-text.svg'
import smsIcon from '../../assets/images/SMSenviado.svg'
import './styles/textInputField.css'

interface TextInputFieldProps {
  inputType: HTMLInputTypeAttribute
  id: string
  label?: string
  value: string
  callbackFunction?: (string) => void
  isError?: boolean
  errorMessage?:
    | null
    | string
    | FieldError
    | Merge<FieldError, FieldErrorsImpl<any>>
  margins?: string
  otherStyles?: string
  name?: string
  [x: string]: any
}

const TextInputField = ({
  inputType,
  id,
  value,
  callbackFunction,
  label = null,
  isError = false,
  errorMessage = null,
  margins = '',
  otherStyles = '',
  name = '',
  ...otherProps
}: TextInputFieldProps) => {
  const [revealPass, setRevealPass] = useState(false)

  return (
    <>
      <div
        className={`flex bg-white transition duration-200 overflow-hidden
      md_input w-full border ${
        margins || 'my-2'
      } border-gray-500 rounded placeholder-purple-900 small-text-placeholder ${
          isError ? 'border-2 border-red-900' : 'border-gray-500'
        } focus:outline-purple-900 font-medium focus:ring-gray-300 focus:ring-4 focus:ring-offset-0 focus:border-purple-900 ${otherStyles}`}
      >
        {inputType === 'tel' && (
          <img src={smsIcon} alt='' className='w-6 h-6 my-4 ml-4' />
        )}
        <div
          className={`w-full ${
            inputType === 'textarea' ? 'h-20' : 'h-[3.375rem]'
          }`}
        >
          {inputType === 'textarea' ? (
            <textarea
              id={id}
              maxLength={90}
              key={id}
              value={value}
              onChange={callbackFunction}
              name={name}
              placeholder=' '
              className={`leading-5 border-none h-full w-full resize-none ${otherStyles}`}
              {...otherProps}
            />
          ) : (
            <input
              id={id}
              key={id}
              type={revealPass ? 'text' : inputType}
              value={value}
              onChange={(val) => callbackFunction && callbackFunction(val)}
              placeholder=' '
              name={name}
              className={`border-none appearance-none
          md_input w-full h-14 ${
            inputType === 'tel' ? 'pt-2.5' : 'pt-6'
          } placeholder-black placeholder-opacity-50 small-text-placeholder ${otherStyles}`}
              {...otherProps}
            />
          )}

          {inputType === 'textarea' ? null : (
            <label
              htmlFor={id}
              className='md_label block font-normal text-xs text-black scale-75 pointer-events-none'
            >
              {label}
            </label>
          )}
        </div>
        {inputType === 'password' && (
          <button
            className='px-2.5 relative z-50'
            onClick={() => {
              setRevealPass((prevState) => !prevState)
            }}
            type='button'
          >
            <img
              src={revealPass ? hidePassTextIcon : viewPassTextIcon}
              alt='Ocultar / Mostrar contraseña'
            />
          </button>
        )}
      </div>
      {isError ? (
        <p className='text-red-900 font-bold text-xs ml-1'>{errorMessage}</p>
      ) : null}
    </>
  )
}

export default TextInputField
